<div
  class="lecturer-information"
  [ngStyle]="{
    '--color50': category.color50,
    '--color0': category.color0,
    '--color70': category.color70,
    '--color80': category.color80,
    '--color90': category.color90,
  }">
  <div class="lecturer-information-content">
    <div class="lecturer-avatar">
      <app-avatar
        placeholderBackgroundColor="#EEF3EB"
        [placeholderColor]="category.color0"
        [user]="lecturer"></app-avatar>
    </div>
    <div class="lecturer-informations">
      <span class="font-medium-headline-small">
        {{ getUserFullName(lecturer) }}
      </span>
      @if (lecturer?.jobTitle) {
        <span class="font-regular-body-large font-color-black">
          {{ lecturer.jobTitle }}
        </span>
      }
      @if (lecturer?.description1) {
        <span class="font-regular-body-large font-color-black">
          {{ lecturer.description1 }}
        </span>
      }
      @if (lecturer?.description2) {
        <span class="font-regular-body-large font-color-black">
          {{ lecturer.description2 }}
        </span>
      }
      @if (lecturer?.description3) {
        <span class="font-regular-body-large font-color-black">
          {{ lecturer.description3 }}
        </span>
      }
    </div>
  </div>
  <div class="lecturer-actions">
    <button
      type="button"
      (click)="viewLecturerVita()"
      class="inwi-icon-text-button-medium-outline align-self-stretch">
      <div class="button-content">
        <div class="button-icon">
          <i class="fa-regular fa-sparkle"></i>
        </div>
        <div class="button-text">Zur vollständigen Vita</div>
      </div>
    </button>
    <button
      type="button"
      (click)="viewLecturerSeminars()"
      class="inwi-icon-text-button-medium-outline align-self-stretch">
      <div class="button-content">
        <div class="button-icon">
          <i class="fa-regular fa-graduation-cap"></i>
        </div>
        <div class="button-text">Zu den Seminaren</div>
      </div>
    </button>
  </div>
</div>
